<template>
    <!-- <div class="container photos photo-carusel---">
        <div class="__control">
            <ul>
                <li v-for="(item, index) in photos" :key="index">
                    <img :src="item.src" :srcset="item.srcset" :sizes="item.sizes" loading="lazy">
                </li>
            </ul>
        </div>

    </div> -->
    <div class="container gallery-container">
        <div class="scroll-container" @wheel.prevent="handleScrollGallery">
            <div class="grid-container">
                <div v-for="(image, index) in images" :key="index"
                    @click="() => { openModal(index) }"
                    class="grid-item"
                    :class="image.orientation + ' img-' + (index % 12 + 1)"
                    >
                    <!-- <img :src="image.src" :srcset="image.srcset" :sizes="image.sizes" :alt="image.alt" loading="lazy" /> -->
                    <img :id="'img-'+index" :src="image.src_320" loading="lazy" />
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="grid-container">
        <div v-for="(image, index) in images" :key="index" class="grid-item" @click="() => { openModal(index) }">
            <img :src="image.src" :srcset="image.srcset" :alt="image.alt" loading="lazy" />
        </div>
    </div> -->
    <div class="container __all-images">
        <div class="">
            <IconCloud/><a href="https://disk.yandex.ru/d/Aiad5es5HDykoA" target="_blank">Все фото можно посмотреть и скачать по ссылке</a>
        </div>
    </div>

    <div v-if="showModal" class="modal" @click="closeModal">
        <div class="modal-content" @wheel="handleScrollPhoto">
            <img :src="currentImage.src" :srcset="currentImage.srcset" :sizes="currentImage.sizes" :class="currentImage.orientation" :alt="currentImage.alt" />
            <button class="__prev" @click.stop="prevImage"><ArrowLeft/></button>
            <button class="__next" @click.stop="nextImage"><ArrowRight/></button>
        </div>
    </div>
</template>
<script>
// import RutubePlayer from './RutubePlayer.vue'
import ArrowLeft from '@/icons/ArrowLeft.vue'
import ArrowRight from '@/icons/ArrowRight.vue'
import IconCloud from '@/icons/IconCloud.vue'

export default {
    name: 'VideoBlock',
    components: { ArrowLeft, ArrowRight, IconCloud },
    props: {},
    data() {
        return {
            showModal: false,
            currentImageIndex: 0,
            images: [],
            wheelLastPosition: 0,
            // img: 0,
        }
    },
    mounted() {
        // document.addEventListener()
        // window.onresize = () => {
        //     const newWidth = window.innerWidth;
        //     const newHeight = window.innerHeight;
        //     console.log(`Новый размер окна: ${newWidth}x${newHeight}`);
        // };
        this.fetchData()
    },
    methods: {
        openModal(index) {
            console.log('openModal',index)
            
            this.showModal = true;
            this.currentImageIndex = index;
            document.body.style.overflow = 'hidden'
        },
        closeModal() {
            this.showModal = false;
            document.body.style.overflow = 'auto'
            // const scrollBox = document.querySelector('.gallery-container .scroll-container')
            // const imageId = scrollBox.querySelector(`#img-${this.currentImageIndex}`)
            // imageId.scrollIntoView()
        },
        prevImage() {
            this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
        },
        nextImage() {
            this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
        },
        handleScrollGallery: function(event) {
            // console.log('handleScrollGallery')
            
            // const scrollBox = document.getElementById('.rutube-carusel .__control ul');
            const scrollBox = document.querySelector('.gallery-container .scroll-container')
            // let lastPosition = 0;

            // Обработка события прокрутки
            // scrollBox.addEventListener('wheel', function(e) {
            // e.preventDefault(); // Предотвращаем стандартную вертикальную прокрутку

            // Определяем смещение относительно предыдущей позиции
            const delta = event.deltaY * 1; // Коэффициент скорости прокрутки

            // Текущая позиция плюс новое смещение
            const newPosition = this.wheelLastPosition - delta;

            // Ограничиваем диапазон прокрутки, чтобы предотвратить выход за пределы содержимого
            const maxLeftOffset = -(scrollBox.scrollWidth - scrollBox.offsetWidth);
            const boundedPosition = Math.max(maxLeftOffset, Math.min(newPosition, 0));

            // Устанавливаем новую позицию
            scrollBox.scrollTo({
                left: boundedPosition * -1,
                behavior: 'smooth' // плавность перехода
            });
            // console.log('handleScrollThumb', newPosition, boundedPosition)
            // Запоминаем последнюю позицию
            this.wheelLastPosition = boundedPosition;
        },
        handleScrollPhoto: function(event) {
            if ( event.deltaY > 0) {
                this.nextImage()
            }else{
                this.prevImage()
            }
        },
        // handleClickThumb: function(item,index) {
        //     this.videoId = item.videoId
        //     this.currentIndex = index
        // },
        // handleScrollThumb: function(event) {
        //     console.log('handleScrollThumb')
            
        //     // const scrollBox = document.getElementById('.rutube-carusel .__control ul');
        //     const scrollBox = document.querySelector('.photo-carusel .__control ul')
        //     // let lastPosition = 0;

        //     // Обработка события прокрутки
        //     // scrollBox.addEventListener('wheel', function(e) {
        //     // e.preventDefault(); // Предотвращаем стандартную вертикальную прокрутку

        //     // Определяем смещение относительно предыдущей позиции
        //     const delta = event.deltaY * 0.5; // Коэффициент скорости прокрутки

        //     // Текущая позиция плюс новое смещение
        //     const newPosition = this.wheelLastPosition - delta;

        //     // Ограничиваем диапазон прокрутки, чтобы предотвратить выход за пределы содержимого
        //     const maxLeftOffset = -(scrollBox.scrollWidth - scrollBox.offsetWidth);
        //     const boundedPosition = Math.max(maxLeftOffset, Math.min(newPosition, 0));

        //     // Устанавливаем новую позицию
        //     scrollBox.scrollTo({
        //         left: boundedPosition * -1,
        //         behavior: 'smooth' // плавность перехода
        //     });
        //     console.log('handleScrollThumb', newPosition, boundedPosition)
        //     // Запоминаем последнюю позицию
        //     this.wheelLastPosition = boundedPosition;
        // },
        // imgClassName: function() {
        //     this.img = this.img % 12 + 1
        //     return "img-"+this.img
        // },
        fetchData: async function() {
            try {
                const response = await fetch('/assets/img/images.json');
                const data = await response.json();
                // this.photos = data;
                this.images = data;
            } catch (err) {
                console.error('Ошибка загрузки данных:', err.message);
            }
        }
    },
    computed: {
        currentImage: function() {
            return this.images[this.currentImageIndex];
        },
        // imgClassName: function() {
        //     this.img = this.img % 12 + 1
        //     return "img-"+this.img
        // },
    },
}
</script>
<style lang="scss">
.container.gallery-container{
    max-width: 98% !important;
}
.scroll-container{
    display: block;
    max-height: 85vh;
    // width: 6000px;
    position: relative;
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
    &::-webkit-scrollbar {
    // width: 10px; /* Ширина вертикального скролла */
    height: 6px; /* Высота горизонтального скролла */
    }

    /* Полоса прокрутки */
    &::-webkit-scrollbar-track {
    background: #2336ffb9; /* Цвет фона дорожки */
    border-radius: 3px; /* Скругление краев */
    }

    /* Ползунок (thumb) */
    &::-webkit-scrollbar-thumb {
    background: #006aff; /* Основной цвет ползунка */
    border-radius: 3px; /* Скругленные углы */
    }

    /* Изменение цвета ползунка при наведении */
    &::-webkit-scrollbar-thumb:hover {
    background: #c7dbff; /* Темнее при наведении */
    }

    /* Горизонтальная полоса прокрутки */
    &::-webkit-scrollbar-horizontal {
    height: 10px; /* Высоту можно уменьшить или увеличить */
    }

    @media screen and (min-width: 900px) {
        &::-webkit-scrollbar {
            height: 10px;
        }
        &::-webkit-scrollbar-track {
            border-radius: 5px;
        }
    }
    /* Только вертикальная полоса прокрутки */
    // &::-webkit-scrollbar-vertical {
    // width: 10px; /* Ширину можно изменять */
    // }
    .grid-container{
        width: 80000px;
        // width: fit-content;
        // gap: .5em;
        // display: grid;
        // grid-template-rows: repeat( auto-fill, minmax(150px, 1fr));
        // // grid-template-columns: repeat( 1fr 1fr);
        // grid-auto-rows: auto;
        display: grid;
        // grid-template-areas: "img-1 img-1 img-6 img-8 img-9 img-10"
        //                      "img-1 img-1 img-5 img-7 img-7 img-11"
        //                      "img-2 img-3 img-4 img-7 img-7 img-12"
        // ;
        // grid-template-columns: auto;
        // grid-template-rows: 1;

        gap: 10px 10px;
        // &:first-child{
        //     column-gap: 0;
        // }
        padding: 10px 0px;
        @media screen and ( max-height: 747px ) and (orientation: landscape) {
            grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
            grid-template-rows: repeat(3, 99px);
        }
        // grid-template-rows: repeat(2, minmax(200px, 1fr));
        // grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));

        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-template-rows: repeat(3, 200px);
        grid-auto-flow: column dense;
        // grid-auto-columns: auto;
        // grid-template-rows: repeat(auto-fill);
        .grid-item{
            // align-self: center;
            img{
                border-radius: 6px;
                object-fit: cover;
                // width: 100%;
                // height: auto;
                // &.vert{
                //     width: auto;
                //     height: 100%;
                // }
                // max-width: 320px;
                width: 100%;
                // // width: 300px;
                height: 100%;
                // object-fit: contain;
            }
        }
        .vert{
            grid-row: span 2;
        }
        // .img-1{
        //     grid-area: img-1;
        // }
        // .img-2{
        //     grid-area: img-2;
        // }
        // .img-3{
        //     grid-area: img-3;
        // }
        // .img-4{
        //     grid-area: img-4;
        // }
        // .img-5{
        //     grid-area: img-5;
        // }
        // .img-6{
        //     grid-area: img-6;
        // }
        // .img-7{
        //     grid-area: img-7;
        // }
        // .img-8{
        //     grid-area: img-8;
        // }
        // .img-9{
        //     grid-area: img-9;
        // }
        // .img-10{
        //     grid-area: img-10;
        // }
        // .img-11{
        //     grid-area: img-11;
        // }
        // .img-12{
        //     grid-area: img-12;
        // }
    }
}
// .grid-container {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); /* Адаптивные колонки */
//   gap: 1rem; /* Расстояние между элементами */
//   padding: 1rem;
  
//   .grid-item {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     overflow: hidden;
//     border-radius: 0.5rem;
//     background-color: #f1f1f1;
    
//     img {
//       width: 100%;
//       height: 100%;
//       object-fit: cover; /* Сохраняет пропорции изображения и обрезает лишнее */
//     }
//   }
// }
.__all-images{
    display: flex;
    justify-content: center;
    margin-top: 15px;
    div{
        overflow: hidden;
        display: flex;
        align-items: center;
        // justify-content: space-around;
        background: #2128a53b;
        color: #fff;
        padding: 5px 15px;
        max-height: 60px;
        // max-width: 90%;
        border-radius: 15px;
        justify-self: center;
        a{
            margin-left: .5em;
            color: #fff;
        }
        svg{
            height: 50px;
            width: 50px;
        }
        // img{
        //     width: 100%;
        //     height: 100%;
        //     object-fit: contain;
        // }
    }
}

/* Медиазапросы для разных разрешений */
// @media screen and (min-width: 600px) {
//   .grid-container {
//     grid-gap: 1.5rem;
//   }
// }

// @media screen and (min-width: 900px) {
//   .grid-container {
//     grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
//   }
// }

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  &-content {
    overflow: hidden;
    // overflow: auto;
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    position: relative;
    width: 98%;
    height: 98%;
    // max-width: 98%;
    // max-height: 98%;
    
    button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #176cff52;
      border: none;
    //   color: white;
    //   font-size: 24px;
      cursor: pointer;
      line-height: 0;
      border-radius: 15px;
    //   &:hover{
    //     background: darken(#176cff52, 15%);
    //   }
      &.__prev {
        left: 10px;
      }
      
      &.__next {
        right: 10px;
      }
      svg{
        width: 50px;
        height: 50px;
        stroke: #ffffff;
      }
    }
    img {
        // width: 100%;
        // height: 100%;
        max-width: 100%;
        max-height: 100%;
        border-radius: 5px;
        object-fit: contain;
        // width: 100%;
        // height: auto;

        // &.vert {
        //     width: auto;
        //     height: 100%;
        // }
    }
  }
}

// .v-enter-active,
// .v-leave-active {
//     transition: opacity .2s ease;
// }
// .v-enter-from,
// .v-leave-to {
//     opacity: 0;
// }


// .photos{
//     ul{
//         list-style: none;
//         margin: 0;
//         padding: 0;
//         li{

//         }
//     }
// }
// .photo-carusel{
//     .__control{
//         padding-top: 10px;
//         padding-bottom: 10px;
//         ul{
//             list-style: none;
//             margin: 0;
//             padding: 4px;
//             // padding-bottom: 10px;
//             display: flex;
//             flex-direction: row;
//             overflow-x: scroll;
//             li{
//                 max-width: 125px;
//                 min-width: 125px;
//                 button{
//                     background: none;
//                     border: none;
//                     cursor: pointer;
//                     transition: .3s;
//                     border: solid 1px #ffffff25;
//                     border-radius: 5px;
//                     margin-right: 4px;
//                     padding: 0;
//                     overflow: hidden;
//                     :last-child{
//                         margin-right: 0;
//                     }
//                     // border-width: 5%;
//                     &:hover{
//                         transition: .3s;
//                         transform: scale(1.05);
//                     }
//                     &.__active{
//                         border: solid 1px #ffffff9e;
//                         // border-width: 80%;
//                     }
//                 }
//                 img{
//                     width: 100%;
//                     height: auto;
//                     // border-radius: 5px;
//                 }
//             }
//         }
//         /* Базовые настройки для всех элементов */
//         ul{
//             &::-webkit-scrollbar {
//             // width: 10px; /* Ширина вертикального скролла */
//             height: 6px; /* Высота горизонтального скролла */
//             }
    
//             /* Полоса прокрутки */
//             &::-webkit-scrollbar-track {
//             background: #f1f1f100; /* Цвет фона дорожки */
//             border-radius: 3px; /* Скругление краев */
//             }
    
//             /* Ползунок (thumb) */
//             &::-webkit-scrollbar-thumb {
//             background: #888; /* Основной цвет ползунка */
//             border-radius: 3px; /* Скругленные углы */
//             }
    
//             /* Изменение цвета ползунка при наведении */
//             &::-webkit-scrollbar-thumb:hover {
//             background: #555; /* Темнее при наведении */
//             }
    
//             /* Горизонтальная полоса прокрутки */
//             &::-webkit-scrollbar-horizontal {
//             height: 6px; /* Высоту можно уменьшить или увеличить */
//             }
    
//             /* Только вертикальная полоса прокрутки */
//             // &::-webkit-scrollbar-vertical {
//             // width: 10px; /* Ширину можно изменять */
//             // }
//         }
//     }
// }
</style>
